import themes from '@/config/themes';
import media from '@/behaviors/media';

export default {
  messages: state => state.messages,
  selectedTheme: state => state.selectedTheme,
  customThemeOptions: (state, getters, rootState) => state.customThemeOptions,
  globalApplicationTheme: (state, getters, rootState) => {
    return { ...themes[state.selectedTheme], ...state.customThemeOptions, ...media };
  },
  isFooterShown: (state, getters, rootState) => {
    return !Object.entries(state.layoutConfig).length || !state.layoutConfig.hide_footer;
  },
};
